import { Button } from '@chakra-ui/react'
import React from 'react'

const PendingButton = () => {
  return (
    <Button bgColor={"rgba(243, 152, 10, 1)"} padding="0 20px " borderRadius="35px">Pending</Button>
  )
}

export default PendingButton
